import React, { useState, useRef, useEffect } from 'react';
import cn from 'classnames';
import { MdArrowDropUp, MdArrowDropDown } from 'react-icons/md';
import useOutsideClick from '../../hooks/useOutsideClick';
import OptionItem from './OptionItem';
import styles from './select.module.scss';

export default function Select(props) {
   const { options, defaultValue, placeholder, onChange, contained } = props;
   const ref = useRef(null);
   const [open, setOpen] = useState(false);
   const [selected, setSelected] = useState(options.find((x) => x.id === defaultValue) || null);

   // este useEffect vuelve el selected a 0 si las opciones del selector cambiaron
   useEffect(() => {
      if (options.filter((x) => x.id === selected?.id).length < 1) {
         setSelected(defaultValue);
      }
   });

   useOutsideClick(ref, () => {
      if (open) {
         setOpen(false);
      }
   });

   const handleSelect = (x) => {
      setSelected(x);
      onChange(x);
      setOpen(false);
   };

   const renderOptions = () => {
      return options.map((x) => (
         <OptionItem
            key={x.id}
            label={x.value}
            onClick={() => handleSelect(x)}
            active={selected?.id === x.id}
         />
      ));
   };

   const contentClass = cn({
      [styles.content]: true,
      [styles['content--visible']]: open,
      [styles.contained]: contained,
   });

   return (
      <div ref={ref} className={styles.container}>
         <button className={styles.btnAction} type="button" onClick={() => setOpen(!open)}>
            <span>{selected ? selected.value : placeholder}</span>
            {open && <MdArrowDropUp size={20} />}
            {!open && <MdArrowDropDown size={20} />}
         </button>

         <div className={contentClass}>
            <ul>{renderOptions()}</ul>
         </div>
      </div>
   );
}
